var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{key:"QuotazioneRCAForm",staticClass:"px-5",attrs:{"fluid":""}},[_c('FastQuotationStepperForm',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }